import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { getColor } from "aible/Tile/Tile";
import TileIcon from "aible/Tile/TileIcon";

import styles from "./style.module.css";

export default class TileSubtitle extends React.PureComponent {
  getColor() {
    const { color } = this.props;

    return getColor(color);
  }

  render() {
    const {
      className,
      style,
      children,

      icon,
      color,

      noBorder,
      hide,

      ...retProps
    } = this.props;

    return (
      <div
        className={
          styles.tileSubtitleWrapper +
          " " +
          (noBorder ? styles.noBorder : "") +
          " " +
          (hide ? styles.hide : "") +
          " " +
          (className ? className : "")
        }
        style={{
          background: this.getColor(),
          color: color && color !== "default" ? undefined : "#4B495B",
          ...style
        }}
        {...retProps}
      >
        <TileIcon icon={icon} style={{ marginRight: "15px" }} />
        {typeof children === "string" ? <div className={styles.tileSubtitle}>{children}</div> : children}
      </div>
    );
  }
}
